"use client";

import { createContext, useState, useEffect, useContext } from "react";
import { toast } from "react-hot-toast";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // ✅ cart is object with cartItems array
  const [cart, setCart] = useState({ cartItems: [] });
  const [coupon, setCoupon] = useState(null);

  // Load from localStorage
  useEffect(() => {
    const storedCart = localStorage.getItem("cart");
    const storedCoupon = localStorage.getItem("coupon");

    if (storedCart) {
      setCart(JSON.parse(storedCart));
    }

    if (storedCoupon) {
      setCoupon(JSON.parse(storedCoupon));
    }
  }, []);

  // =========================
  // ADD TO CART (FIXED)
  // =========================
  const addItemToCart = (itemData) => {
    const item = { ...itemData };
    
    setCart((prev) => {
      const existingIndex = prev.cartItems.findIndex(
        (i) => i.product === item.product
      );

      let updatedCartItems;

      // If item exists → increase quantity
      if (existingIndex !== -1) {
        updatedCartItems = prev.cartItems.map((i) =>
          i.product === item.product
            ? {
              ...i,
              quantity: (i.quantity || 1) + 1,
            }
            : i
        );
      } else {
        updatedCartItems = [
          ...prev.cartItems,
          { ...item, quantity: 1 },
        ];
      }

      const newCart = { cartItems: updatedCartItems };

      localStorage.setItem(
        "cart",
        JSON.stringify(newCart)
      );

      toast.success("Item added to cart");

      return newCart;
    });
  };

  // =========================
  // DELETE SINGLE ITEM
  // =========================
const deleteItemFromCart = (id) => {
  setCart((prev) => {
    const updatedCartItems = prev.cartItems.filter(
      (item) => item.product !== id
    );

    const newCart = {
      cartItems: updatedCartItems,
    };

    localStorage.setItem(
      "cart",
      JSON.stringify(newCart)
    );

    // Remove coupon if cart empty
    if (updatedCartItems.length === 0) {
      localStorage.removeItem("coupon");
      setCoupon(null);
    }

    toast.success("Item removed from cart");

    return newCart;
  });
};

const updateQuantity = (id, quantity) => {
  if (quantity < 1) return;

  setCart((prev) => {
    const updatedItems = prev.cartItems.map((item) =>
      item.product === id
        ? { ...item, quantity }
        : item
    );

    const newCart = {
      cartItems: updatedItems,
    };

    localStorage.setItem(
      "cart",
      JSON.stringify(newCart)
    );

    return newCart;
  });
};

  
  // =========================
  // CLEAR CART
  // =========================
  const deleteAllItemsFromCart = () => {
    const emptyCart = { cartItems: [] };

    localStorage.setItem(
      "cart",
      JSON.stringify(emptyCart)
    );

    localStorage.removeItem("coupon");
    setCoupon(null);
    setCart(emptyCart);
  };

  // =========================
  // COUPON
  // =========================
  const addCoupon = ({ coupon }) => {
    localStorage.setItem(
      "coupon",
      JSON.stringify({ coupon })
    );

    setCoupon({ coupon });

    toast.success("Coupon applied successfully");
  };

  

  return (
    <CartContext.Provider
      value={{
        cart,
        coupon,
        addItemToCart,
        deleteItemFromCart,
        deleteAllItemsFromCart,
        updateQuantity,
        addCoupon,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

// =========================
// HOOK
// =========================
export const useCartContext = () => {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error(
      "useCartContext must be used within CartProvider"
    );
  }

  return context;
};

export default CartContext;